import { ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import axios from "axios";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, err) => {
        const status = axios.isAxiosError(err)
          ? err.response?.status
          : undefined;
        if (status !== undefined && status >= 400 && status < 500) return false;
        return failureCount < 3;
      },
    },
  },
});
queryClient.getQueryCache().subscribe((event) => {
  const { meta, state } = event.query;
  const { onRemoveFromCache } = meta || {};
  if (event.type === "removed" && typeof onRemoveFromCache === "function") {
    onRemoveFromCache(state);
  }
});

export const ReactQueryProvider = ({ children }: { children: ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools />
      {children}
    </QueryClientProvider>
  );
};
